<template>
    <div>
        <span>{{ $t('notification.tableWidgetDeleted', {
            actor: $_.get(activity, 'actorUser.name'),
            tableName: $_.get(activity, 'payload.tableName'),
            pageName: $_.get(activity, 'payload.pageName'),
            widgetTitle: $_.get(activity, 'payload.widgetTitle'),
            widgetType: $_.get(activity, 'payload.widgetType')
        }) }}</span>
    </div>
</template>

<script>
export default {
    name: "TableWidgetDeleted",
    props: {
        activity: {
            type: Object,
            required: true
        }
    }
};
</script>

